'use strict';

/*
 * database definition abstraction
 *
 * dbDefinition.js
 *
 * (c) 2019 FSZ GmbH
 * All rights reserved.
 */

import {DbDefinition} from './dbDefinition/DbDefinitionMapperUtilities';
import DbSchema, {Schemas} from './dbDefinition/DbSchema';
import dbDefinition from './definitions/dbDefinition';


class DbDefinitionMapper {

    status : Status | 'allNonHistory' | undefined;
    isHistoryRequest : boolean | undefined;
    noHistorySnapshot : boolean | undefined;

    /**
     * The database schemas handled by this.
     */
    readonly schemas : Schemas;


    constructor( definition : DbDefinition ) {
        this.schemas = {};

        // init schemas
        for ( const schema in definition.schemas ) {
            const schemaName = schema.toUpperCase();
            this.schemas[ schemaName ] = new DbSchema( schemaName, definition.schemas[ schema ] );
        }
    }
}

const dbDefinitionMapper = new DbDefinitionMapper( dbDefinition );
export default dbDefinitionMapper;
